import { createSelector } from "selectors";

import { selectSelectedBusiness } from "./ui";

export const selectHasAuthedUser = createSelector(
  (state) => state.authedUser.data,
  (authedUser) => {
    const _authedUser = authedUser ?? {};
    const hasAuthedUser = Object.keys(_authedUser).length > 0;
    return hasAuthedUser;
  }
);

export const selectAuthedUserUid = createSelector(
  (state) => state.authedUser.data,
  (authedUser) => authedUser.uid
);

export const selectBranchUser = (authedUser, businessUid) => {
  return authedUser.branches?.find(
    (branch) => branch.businessUid === businessUid
  );
};

export const selectBranchUserInfo = createSelector(
  (state, businessUid) => businessUid || selectSelectedBusiness(state),
  (state) => state.authedUser.data,
  (businessUid, authedUser) => selectBranchUser(authedUser, businessUid)
);

export const isUserActive = (authedUser, businessUid) => {
  if (authedUser.role === "root") return true;
  const branchUser = selectBranchUser(authedUser, businessUid);
  return Boolean(branchUser?.active);
};

export const selectUserActive = createSelector(
  (state, businessUid) => businessUid || selectSelectedBusiness(state),
  (state) => state.authedUser.data,
  (businessUid, authedUser) => isUserActive(authedUser, businessUid)
);

export const selectUserLoading = (state) =>
  Boolean(state.authedUser?.data?.loading);
export const selectUserError = (state) =>
  Boolean(state.authedUser?.data?.error);

const getBusinessUids = (authedUser) => authedUser.businessUids;
const getRootUser = (authedUser) => authedUser.rootUser;
const getUserEmail = (authedUser) => authedUser.email;

export const selectBusinessUids = createSelector(
  (state) => state.authedUser.data,
  (authedUser) => getBusinessUids(authedUser)
);

export const selectUserBusinesses = createSelector(
  (state) => state.authedUser.data,
  (authedUser) => authedUser.branches || []
);

export const selectRootUser = createSelector(
  (state) => state.authedUser.data,
  (authedUser) => getRootUser(authedUser)
);

export const selectUserEmail = createSelector(
  (state) => state.authedUser.data,
  (authedUser) => getUserEmail(authedUser)
);

export const getUserRole = (authedUser, businessUid) => {
  if (authedUser.role === "root") return "admin";
  const branchUser = selectBranchUser(authedUser, businessUid);
  const role = branchUser?.role;
  return role;
};

export const selectUserRole = createSelector(
  (state, businessUid) => businessUid || selectSelectedBusiness(state),
  (state) => state.authedUser.data,
  (businessUid, authedUser) => getUserRole(authedUser, businessUid)
);
